import z from 'zod';

const userTypes = [
  'administrator',
  'assessor',
  'author',
  'editor',
  'instructor',
  'learner',
  'manager',
  'support',
  'user',
] as const;

const isValidCulture = (culture: string): boolean => {
  const cultureRegex = /^[a-z]{2}-[A-Z]{2}$/; // language code-country/region code
  return cultureRegex.test(culture);
};

export default z.object({
  id: z.string(),
  type: z.enum(userTypes).optional(),
  organisationId: z.string().optional(),
  cultureInfo: z
    .string()
    .refine(culture => isValidCulture(culture), {
      message: "Invalid culture string. Culture should be in the format 'xx-XX'.",
    })
    .optional(),
});
